import { useState } from "react";
import { FaChartLine } from "react-icons/fa";
import BTC from "../../../assets/images/BTCPic.png"
import { GoChevronDown } from "react-icons/go";
import { GoChevronUp } from "react-icons/go";

export default function TradeSymbol({ selectedItem, setOpenModal }) {
  const [market, setMarket] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  
  const marketTypes = [
    { value: "forex", label: "Forex", description: "Foreign Exchange Market" },
    { value: "crypto", label: "Cryptocurrency", description: "Digital Assets" },
    { value: "stocks", label: "Stocks", description: "Equity Market" },
    { value: "commodities", label: "Commodities", description: "Raw Materials" }
  ];

  const handleSelect = (value) => {
    setMarket(value);
    setIsOpen(false);
  };



  return (
    <form

      className="space-y-4 p-5 bg-white rounded-xl shadow-md"
    >
      <div className="text-[18px] font-bold">
        Trading Symbol
      </div>
      {/* Symbol Input */}
      <div className="relative flex items-center">
        <FaChartLine className="absolute left-4 text-gray-500 mr-3" size={18} />
        {
          selectedItem ?
            <div onClick={() => { setOpenModal(true) }} className="w-full h-[58px] border border-[#D1D5DB] rounded-[8px] p-4 items-center justify-center flex flex-row pl-10">
              <div className="flex flex-row w-full min-h-[34px] justify-start gap-2 items-center">
                <img src={selectedItem.image ? `https://api.7-trade.ir/${selectedItem.image?.path}` : BTC} alt={selectedItem?.symbol || ""} className="min-w-[24px] h-[24px] rounded-full content" />
                <p className="text-[18px] text-[#6B7280] leading-[16px]">{selectedItem?.symbol}</p>
              </div>
            </div>
            :
            <div onClick={() => { setOpenModal(true) }} className="w-full h-[58px] border border-[#D1D5DB] rounded-[8px] items-center justify-center flex flex-row ">
              <p className="text-center text-[16px] leading-[24px] text-[#ADAEBC] ps-10 pe-5 whitespace-nowrap truncate ">Enter symbol (e.g., EUR/USD, BTC/USDT)</p>
            </div>
        }

        {/* <input
          type="text"
          value={symbol}
          onChange={(e) => setSymbol(e.target.value)}
          placeholder="Enter symbol (e.g., EUR/USD, BTC/USDT)"
          className="w-full p-4 pl-12 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
        /> */}
      </div>


      {/* Market Select */}
      <div className="relative">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full p-4 border border-gray-300 rounded-lg cursor-pointer hover:border-primary transition-all flex justify-between items-center"
        >
          <span className="text-gray-700">
            {market ? marketTypes.find(m => m.value === market)?.label : "Select Market Type"}
          </span>
          {isOpen ? (
            <GoChevronUp className="text-gray-500" size={20} />
          ) : (
            <GoChevronDown className="text-gray-500" size={20} />
          )}
        </div>
        

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg">
            {marketTypes.map((type) => (
              <div
                key={type.value}
                onClick={() => handleSelect(type.value)}
                className={`p-3 hover:bg-gray-50 cursor-pointer transition-colors
                  ${market === type.value ? 'bg-primary/5 text-primary' : 'text-gray-700'}
                  ${market === type.value ? 'font-medium' : 'font-normal'}
                `}
              >
                <div className="text-[15px]">{type.label}</div>
                <div className="text-xs text-gray-500">{type.description}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Submit */}

    </form>
  );
}
